import React, { useEffect, useState, FC } from "react";
import { Button, Modal, Grid } from 'semantic-ui-react';

interface IProps {
    open: boolean,
    onChange: any,
    onClose: any
}

const DeleteTableModal: FC<IProps> = ({ open, onChange, onClose }) => {

    const onDeleteClick = () => {
        onChange(true);
    }

    const onCancelClick = () => {
        onChange(false);
    }

    useEffect(() => {
    }, []);

    return (
        <Modal
            id="deleteModal"
            open={open}
            onClose={onClose} >
            <Modal.Header>Delete Table</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <div>Are you sure you want to delete this table? </div>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onDeleteClick}>Delete</Button>
                <Button onClick={onCancelClick}>Cancel</Button>
            </Modal.Actions>
        </Modal>
    )
}

export default DeleteTableModal;